'use strict';var SETTINGS_V18=require('./../v18/settings');module.exports=SETTINGS_V18;